import { Box, MenuItem, TextField } from "@mui/material"

export const EnumProperty = ({ label, value, onChange = () => {}, dataInfo }) => {

    const handleOnChange = e => {
        onChange?.(e);
    }

    return (
        <TextField
            select
            variant="filled"
            onChange={handleOnChange}
            value={value}
            label={label}
            sx={{ width: '100%' }}
        >
            <MenuItem value=''><em>none</em></MenuItem>
            {dataInfo.values.map((v, index) => <MenuItem key={index} value={v}>{v}</MenuItem>)}
        </TextField>
    );
}